import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

// empty icon 8x8
// 16x16/check circle/filled.svg
const CHECK_CIRCLE_FILLED_16 = {
	d: 'M10.993 5.757a.999.999 0 00-1.414 0L7.25 8.086l-.793-.793a.999.999 0 10-1.414 1.414l1.5 1.5a.997.997 0 001.414 0l3.036-3.036a.999.999 0 000-1.414zM8 0a8 8 0 110 16A8 8 0 018 0z',
	size: 16,
};
// 24x24/close/outline.svg
const CLOSE_OUTLINE_24 = {
	d: 'M13.414 12l4.293-4.293C17.901 7.513 18 7.254 18 7a.985.985 0 00-.293-.707.996.996 0 00-1.414 0L12 10.586 7.707 6.293a.997.997 0 00-1.414 0 .997.997 0 000 1.414L10.586 12l-4.293 4.293a.997.997 0 000 1.414.997.997 0 001.414 0L12 13.414l4.293 4.293a.997.997 0 001.414 0 1.003 1.003 0 000-1.414L13.414 12z',
	size: 24,
};
const CLOSE_24 = CLOSE_OUTLINE_24;
// 24x24/arrow left/outline.svg
const ARROW_LEFT_OUTLINE_24 = {
	d: 'M2.293 12.707l6 6a.997.997 0 001.414 0c.194-.194.292-.452.293-.707a.989.989 0 00-.293-.707L5.414 13H21a1 1 0 100-2H5.414l4.293-4.293a.997.997 0 000-1.414A1.006 1.006 0 009 5a.989.989 0 00-.707.293l-6 6a.997.997 0 000 1.414z',
	size: 24,
};
const ARROW_LEFT_24 = ARROW_LEFT_OUTLINE_24;

const mapyIconCss = ":host{display:inline-block}:host(:not([size])),:host([size=\"24\"]){width:24px;height:24px}:host([size=\"8\"]){width:8px;height:8px}:host([size=\"16\"]){width:16px;height:16px}:host([size=\"32\"]){width:32px;height:32px}:host svg{display:block;width:100%;height:100%;fill:currentColor}:host svg path:nth-child(2){color:var(--Icon-Secondary, currentColor)}";

const MapyIcon$1 = /*@__PURE__*/ proxyCustomElement(class MapyIcon extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 24;
  }
  render() {
    return (h(Host, null, h("svg", { x: "0px", y: "0px", viewBox: `0 0 ${this.size} ${this.size}`, focusable: "false" }, Array.from(this.hostElement.children).map(child => h("path", { "fill-rule": "evenodd", d: `${child.hasAttribute('d') ? child.getAttribute('d') : ''}` })))));
  }
  get hostElement() { return this; }
  static get style() { return mapyIconCss; }
}, [1, "mapy-icon", {
    "size": [514]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-icon"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-icon":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyIcon$1);
      }
      break;
  } });
}
defineCustomElement$1();
const defineCustomElement = defineCustomElement$1;

export { ARROW_LEFT_24 as A, CLOSE_24 as C, CHECK_CIRCLE_FILLED_16 as a, defineCustomElement as d };

//# sourceMappingURL=mapy-icon3.js.map